import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanDiscountConnectionRoot } from "./discount-connection/root";
import { QuestionPlanMinAndMaxPeopleNum } from "./min-and-max-people-num";
import { QuestionPlanOptionConnection } from "./option-connection";
import { QuestionPlanRoomChangeDisable } from "./room-change-disable";
import { QuestionPlanRoomConnection } from "./room-connection";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	connection: PlanCategoriesAndManagerStore["connection"];
};

export const QuestionPlanConnection = ({ connection }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="部屋" categoryStore={connection}>
				<QuestionPlanRoomConnection />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="オプション" categoryStore={connection}>
				<QuestionPlanOptionConnection />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="ディスカウント" categoryStore={connection}>
				<QuestionPlanDiscountConnectionRoot />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="部屋に関する高度な設定" categoryStore={connection}>
				<QuestionPlanRoomChangeDisable />
				<QuestionPlanMinAndMaxPeopleNum />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionPlanConnection.displayName = "QuestionPlanConnection";
